import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { View } from '../../../../shared/store/view/types';
import { ActivatedRoute, Router } from '@angular/router';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../shared/store/view/views.service';
import { filter, take } from 'rxjs/operators';
import { CarReferenceBrandService } from '../../../../shared/store/car-reference-brand/car-reference-brand.service';
import { CarReferenceBrandModel } from '../../../../shared/store/car-reference-brand/types';
import { filterTrue } from '../../../../shared/pipe/rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'app-car-reference-brand-details',
    templateUrl: './car-reference-brand-details.component.html',
    styleUrls: ['./car-reference-brand-details.component.scss'],
    standalone: false
})
export class CarReferenceBrandDetailsComponent implements OnInit, OnDestroy {
  carReferenceBrandId: number;
  carReferenceBrandModel$: Observable<CarReferenceBrandModel>;
  view$: Observable<View>;

  @Input() modalId: number;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
    private readonly carReferenceBrandService: CarReferenceBrandService,
  ) {
    this.carReferenceBrandModel$ = this.carReferenceBrandService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.carReferenceBrandId = this.route.snapshot.params['id'];

    if (this.modalId) this.carReferenceBrandId = this.modalId;

    this.carReferenceBrandService.getById.call(
      this.carReferenceBrandId.toString(),
    );

    this.carReferenceBrandModel$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@carReferenceBrandDetails', x.name);
      });
    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'carReferenceBrandEdit') {
          this.router.navigate([
            'Crm/CarReferenceBrands/Edit/',
            this.carReferenceBrandId,
          ]);
        }
        if (x == 'carReferenceBrandDelete') {
          this.onDelete();
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  onDelete() {
    let result$ = this.carReferenceBrandService.delete.call(
      this.carReferenceBrandId.toString(),
    );

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.carReferenceBrandService.delete.reset();
      this.router.navigate(['Crm/CarReferenceBrands/List']);
    });
  }

  ngOnDestroy(): void {
    this.carReferenceBrandService.getById.reset();
    this.carReferenceBrandService.delete.reset();
    this.breadcrumbService.set('@carReferenceBrandDetails', ' ');
  }
}
